export const footerSticky = (state = {sticky: true}, action: any) => {
    const footerEl: HTMLElement | null = document.querySelector(".footer");
    const mainEl = document.querySelector("main");

    switch (action.type) {
        case 'STICKY':
            footerEl?.classList.add("fixed");
            return {
                sticky: true
            }
        case 'UN_STICKY':
            footerEl?.classList.remove("fixed");
            return {
                sticky: false
            }
        default:
            return state
    }
}